import React from "react";

import NavBar from "@landing-components/NavBar/NavBar";
import Footer from "@landing-components/Footer/Footer";
import SEO from "@components/seo";

import "./about.scss";

const AboutPage = (props) => {
    return (
        <div className="about-page text-block">
            <SEO type="corporation" metadata={{ title: "Scribe - A Second Brain for you and your team" }} />

            <NavBar theme="light" />

            <div className="about-page-content">
                <h1>A little bit about Scribe</h1>
                <p>My name is Francesco Lanciana and I built Scribe to solve one main problem:</p>
                <p className="key-problem">Knowledge bases don't scale</p>
                <p>
                    I've worked in both small and large teams and across the board knowledge transfer was a
                    consistent problem. It's tempting to just write this off as your team being under too much
                    time pressure or the company culture not supporting it, and honestly these can play a huge
                    part but there is another factor, the tools. Products like Confluence give you a good set
                    of tools for writing content, but provide very little for managing it.
                </p>
                <p>
                    If you are reading this you have probably experienced first hand how quickly information
                    becomes outdated, and as your knowledge base grows, how hard it can be to find anything.
                    On top of that most products out there don't really facilitate collaboration past giving
                    you the ability to edit the same document at the same time. That's nice but creating the
                    content is really only a small part of the picture. What about when you have a question or
                    a suggestion? There is so much I want to Scribe to do, but it will always be building
                    towards the following:
                </p>

                <ul>
                    <li>
                        Being a long term knowledge base for all types of content - not just large documents
                    </li>
                    <li>
                        Give you the tools to scale from 1 person to 10000 without needing people dedicated to
                        maintenance
                    </li>
                    <li>Encouraging collaboration for the lifetime of content</li>
                </ul>

                <h2>Interested?</h2>
                <p>
                    If you've gotten this far you probably already have an idea of how big an impact this
                    could make. If you could give back the time even 1% of the population spend looking for
                    answers that's a really big deal. At the moment it's just me but I'm always looking for
                    interesting people to come join. Email me at{" "}
                    <a href="mailto: hello@scribe.wiki">hello@scribe.wiki</a> if you like the cut of my jib.
                </p>
            </div>

            <Footer />
        </div>
    );
};

export default AboutPage;
